export enum AutodeskAuthNotificationCode {
  B360 = 'B360: Not Authorized',
  'B360-E1' = 'sources.autodeskAccount.authErrors.sourceId',
  'B360-E2' = 'sources.autodeskAccount.authErrors.authCode',
  'B360-E3' = 'sources.autodeskAccount.authErrors.notFound',
  'B360-E4' = 'sources.autodeskAccount.authErrors.internal',
  'B360-E5' = 'sources.autodeskAccount.authErrors.canceled',
}
